import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { getTrainerAssignedData } from "../../redux/features/batchSlice";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useDispatch } from "react-redux";

const SubjectAndTutors = ({ rowData, dispatchData, open, setOpen }) => {
  const { loading, trainerassigneddata } = useSelector((state) => state.batch);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTrainerAssignedData(rowData.course_batch_id));
  }, []);

  const headers = ["Subject", "Tutor"];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 14,
      border: "1px solid #ccc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "1px solid #ccc",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  return (
    <GlobalDialog
      title={"Subject And Tutors"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      content={
        <>
          <Paper
            sx={{
              margin: 1,
              borderRadius: 4,
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #ccc",
                borderCollapse: "collapse",
                marginTop: 2,
              }}
            >
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <StyledTableCell key={index} align="center">
                      {header}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {trainerassigneddata?.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="center">
                      {row.subject_name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.trainer_name === null ? (
                        <Chip
                          variant="outlined"
                          color="warning"
                          label="Not Assigned"
                        />
                      ) : (
                        row.trainer_name
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      }
    />
  );
};

export default SubjectAndTutors;
